
// PROD
export const API_URL = 'https://registration-forms-api.maharashtracet.org';
export const NODE_ENV = 'production'

// UAT
// export const API_URL = 'https://mhcet-reg-uat1.hubblehox.ai/api';
// export const API_URL = 'http://172.16.57.102:3001';
// export const NODE_ENV = 'production'
 
 
// DEV
// export const API_URL = 'https://mhcet-reg-dev.hubblehox.ai/api';
// export const API_URL = 'http://172.16.57.76:3001';    
// export const NODE_ENV = 'production'
 
// LOCAL
// export const API_URL = 'http://localhost:3001';
// export const NODE_ENV = 'production'
 
 
export const AES_KEY = "0a1a57889030315bd571c8f72ba1c3b2ea811e2de93b9e34a4e2e3e88cba2c7a";
export const AES_IV = "76c2b153ff33ba05d5cfaa1ece032868";
// TEST
// export const API_URL = 'https://mhcet-test.praathee.in/api';
// export const NODE_ENV = 'production'
 
 
 
export const itemsPerPage = 5;